import { render } from "./TargetTables.vue?vue&type=template&id=348c5918&scoped=true"
import script from "./TargetTables.vue?vue&type=script&lang=js"
export * from "./TargetTables.vue?vue&type=script&lang=js"

import "./TargetTables.vue?vue&type=style&index=0&id=348c5918&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348c5918"]])

export default __exports__